import t from 'react-translate';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';

import { getAiRolePlay } from 'redux/selectors/timeline';
import {
  ReactComponent as AIPersona,
} from 'styles/icons/ai-persona.svg';
import ProfilePicture from 'org_level_profile/components/profile-picture';
import { shortBar, standardSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';
import { RootState } from 'redux/schemas';
import AiConversationContext from './context';
import useViewedSubmission from './use-viewed-submission';
import { getSelectedAvatarDisplayUrl } from '../ai-config-modal/set-up-instructions/ai-character-utils';

const styles = css`
  align-items: flex-start;
  gap: ${standardSpacing}px;
  .profile {
    width: ${shortBar}px;
  }

  .profile-image {
    width: ${tripleSpacing}px;
    height: ${tripleSpacing}px;
    border-radius: 50%;
    object-fit: cover;
  }
`;
const AvatarContainer = () => {
  const {
    aiRolePlayId,
  } = useContext(AiConversationContext);

  const aiRolePlay = useSelector((state: RootState) => getAiRolePlay(state, aiRolePlayId ?? 0));
  const { profile, isCurrentUserSubmission } = useViewedSubmission();

  const {
    aiCharacterName,
    aiCharacterRole,
    learnerRole,
    aiCharacterFace,
  } = aiRolePlay || {};
  const aiAvatarDisplayUrl = getSelectedAvatarDisplayUrl(aiCharacterFace);

  return (
    <div className='d-flex justify-content-center' css={styles}>
      <div className='profile d-flex flex-column align-items-center mt-1'>
        {aiAvatarDisplayUrl ? (
          <img
            src={aiAvatarDisplayUrl}
            alt={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_CHARACTER_PROFILE.AVATAR()}
            className='profile-image'
          />
        ) : (
          <AIPersona
            width={tripleSpacing}
            height={tripleSpacing}
            role='img'
            aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.AI_CHARACTER_AVATAR()}
          />
        )}
        <p className='mb-0 mt-2 text-regular semi-bold text-align-center'>{aiCharacterName}</p>
        <p className='mb-0 text-small text-gray-2 text-align-center'>{aiCharacterRole}</p>
      </div>
      <div className='profile d-flex flex-column align-items-center mt-1'>
        <ProfilePicture
          profile={profile}
          isRound
          size={tripleSpacing}
        />
        <p className='mb-0 mt-2 text-regular semi-bold text-align-center'>
          {isCurrentUserSubmission
            ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOU()
            : profile?.fullName}
        </p>
        <p className='mb-0 text-small text-gray-2 text-align-center'>{learnerRole}</p>
      </div>
    </div>
  );
};

export default AvatarContainer;
